import { IdSanitizerPipe } from './../../pipes/id-sanitizer.pipe';
import { Location, DatePipe } from '@angular/common';
import { TasksWithoutProjectService } from 'app/view/tasks-without-project/services/tasks-without-project.service';
import { environment } from './../../../../environments/environment.prod';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'app/core/services/auth.service';
import { IconsService } from 'app/shared/services/Modal/icons.service';
import { SharedService } from 'app/shared/services/shared.service';
import { GeneralFinanceService } from 'app/view/New-Finances/services/general-finance.service';
import { FormProjectComponent } from 'app/view/projects/components/form-project/form-project.component';
import { TasksService } from 'app/view/projects/module/tasks/services/tasks.service';
import { ProjectsService } from 'app/view/projects/services/projects.service';
import { ToastrService } from 'ngx-toastr';
import { environment as env } from '../../../../environments/environment';

@Component({
  selector: 'app-new-card-view',
  templateUrl: './new-card-view.component.html',
  styleUrls: ['./new-card-view.component.scss']
})
export class NewCardViewComponent implements OnInit , OnChanges ,AfterViewInit{
  /////////////////////////////////////////////
  allEmployeesName: any[] = []
  /////////////////////////////////////////////

  @Input() item: any ;
  @Input() hideDepartment:boolean ;

  @Input() canView:boolean =true;
  @Input() canEdit:boolean =true;
  @Input() canDelete:boolean =true;
  @Input() comFromWhat: string = ""

  @Output() openModal: any = new EventEmitter();
  @Output() getAllTasks: any = new EventEmitter();
  path: string = env.assetsUrl;
  companyID: number = 0;
  lang: string = "";
  isViewTaskWithProjects:boolean = false;
  ////////////////////////////////////////////////////////
  isInViewTaskWithoutProject: boolean = false;
  timeToArabic: string = "";
  ////////////////////////////////////////////////////////


  constructor(
    public icons: IconsService,
    public _AuthenticationService: AuthenticationService,
    private ngbModal: NgbModal,
    private projectsService: ProjectsService,
    private sharedServ: SharedService,
    private _ActivatedRoute: ActivatedRoute,
    private router: Router,
    private toastrService:ToastrService,
    private _TasksService:TasksService,
    private _GeneralFinanceService:GeneralFinanceService,
    private _TasksWithoutProjectService:TasksWithoutProjectService,
    private _Location:Location,
    private _DatePipe:DatePipe
  ) {

    // Subscribing to the route parameters to extract the 'companyID' and determine the current route value.
    this._ActivatedRoute.paramMap.subscribe((param: any) => {
      // Extracting 'companyID' from route parameters and converting it to a number.
      this.companyID = +param.params['companyID'];
      // Determining the last segment of the current URL path.
      this.comFromWhat = router.url.split("/")[router.url.split("/").length - 1];
    });
    // Retrieving the saved language preference from local storage.
    // Defaults to 'ar' (Arabic) if no preference is found.
    this.lang = JSON.parse(localStorage.getItem('lang_ERP'))?.lang || 'ar';
    // Setting 'comFromWhat' to "projects" if the current URL ends with "projects"; otherwise, it remains an empty string.
    // this.comFromWhat = (this.router.url.endsWith("projects")||this.router.url.includes("projects?departmentId=")) ? "projects" : "";

    // Checking if the current URL contains "projects" and ends with "tasks" to determine the view state.
    this.isViewTaskWithProjects = this.router.url.includes("projects") && this.router.url.endsWith("tasks");

  }

  ngOnChanges(changes: SimpleChanges): void {
    if( changes.currentValue){

      this.item= changes.currentValue
    }
    ////////////////////////////////////////////
   
  }
  ngAfterViewInit(): void {

  }
  ngOnInit(): void {
    if(this._Location.path().includes("tasks-without-project")){
      this.isInViewTaskWithoutProject = true;
    }else{
      this.isInViewTaskWithoutProject = false;
    }
   }

  trackByUserId(index: number, item: any): number {
    return item.id;
  }

  open(item: any, canEdit: boolean , action:string) {
    item.canEdit = canEdit;
    item.action = action;
    this.openModal.emit(item)
    this._TasksWithoutProjectService.isEditing.next(canEdit);
  
  }

  /* --------- only for Add Task Approval --------- */
  AddTaskApproval(id: number, isApproved: boolean, description: string = '') {
    const value: any = {};
    value['id'] = id;
    value['isApproved'] = isApproved;
    description ? value['description'] = description : null;
    this._TasksService.AddTaskApproval(value).subscribe({
      next: (res: any) => {
        this.toastrService.success(res.message);
        this.getAllTasks.emit(true);
      }, error: (err: any) => {
        this.toastrService.error(`${err.error}`);
      }
    })
  }


  /**
   * Emits the item ID to notify observers about the deletion event.
   * @param id - Identifier of the item to be deleted.
  */
  deleteItem(id: number) {
    this.projectsService.deleteSubjectItem.next(id);
  }
  onMouseEnter(item: any){

    this.allEmployeesName = []
   item.forEach(element => {
      this.allEmployeesName.push( " "+ element.name + "  " )
    });
  }
  onMouseLeave(){
    this.allEmployeesName = []
  }
 convertToArabicNumbers(input: string): string {
    const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return input.replace(/\d/g, (digit) => arabicNumbers[parseInt(digit)]);
  }
  DateToArabic(date: string): string {
    let isAm = true;
    // for 12 h time
    const dateObj = new Date(date);
    // const day = dateObj.getDate();
    // const month = dateObj.getMonth() + 1;
    // const year = dateObj.getFullYear();
    let hours = dateObj.getHours();
    
    if (hours > 12) {
      if (hours == 12){
        hours = 12;
        isAm = false
      }else {
      hours = hours - 12;
      isAm = false;
    }}else{
      isAm = true
    }
    
    const minutes = dateObj.getMinutes();
    // const seconds = dateObj.getSeconds();
// const dayInArabic = this.convertToArabicNumbers(day.toString());
// const monthInArabic = this.convertToArabicNumbers(month.toString());
// const yearInArabic = this.convertToArabicNumbers(year.toString());
const hoursInArabic = this.convertToArabicNumbers(hours.toString());
const minutesInArabic = this.convertToArabicNumbers(minutes.toString());
// const secondsInArabic = this.convertToArabicNumbers(seconds.toString());
return ` ${hoursInArabic}:${minutesInArabic} ${isAm ? 'ص' : 'م'} `;
  }
}
